
interface propsToDate {
    dateString: string | null | undefined
}

export default function getDateObject({ dateString }: propsToDate): Date {
    if ((dateString === '') || (dateString === null) || (dateString === undefined)) {
        return new Date()
    } else {
        const parts = dateString.split('.');
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; 
        const year = parseInt(parts[2], 10);
        return new Date(year, month, day)
    }
}